import { Navigate, Route, Routes, useNavigate } from 'react-router-dom';

import { createStandaloneToast } from '@chakra-ui/toast';
import { PrivateRoute } from 'components/PrivateRouter';
import AdminLayout from 'layouts/admin';
import AuthLayout from 'layouts/auth';
import { useEffect } from 'react';
import { signInService } from 'views/services/auth';

// eslint-disable-next-line react-refresh/only-export-components
export const { toast, ToastContainer } = createStandaloneToast({
  defaultOptions: {
    position: 'top-right',
    duration: 5000,
    isClosable: true,
  },
});

const App = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const hasAccessToken = localStorage.getItem('accessToken');
    if (hasAccessToken) {
      signInService.sendRefreshRequest().catch(() => {
        localStorage.removeItem('accessToken');
        signInService.logout();
        navigate('/auth/sign-in');
      });
    } else {
      navigate('/auth/sign-in');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const isDark = localStorage.getItem('darkmode');
    if (isDark === 'true') {
      document.body.classList.add('dark');
    } else {
      document.body.classList.remove('dark');
    }
  }, []);

  return (
    <>
      <Routes>
        <Route path="auth/*" element={<AuthLayout />} />
        <Route
          path="admin/*"
          element={
            <PrivateRoute>
              <AdminLayout />
            </PrivateRoute>
          }
        />
        <Route
          path="/"
          element={
            <PrivateRoute>
              <Navigate to="/admin" replace />
            </PrivateRoute>
          }
        />
      </Routes>
      <ToastContainer />
    </>
  );
};

export default App;
